'use client';

import ArrowBack from 'icons/lib/mobile_back_category.svg';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { LOCALE } from 'utils';

import { useTranslation } from '@/i18n/client';
import { routes } from '@/shared/data/routes';
import { useCurrentLocale } from '@/shared/utils/client';

import { Logo } from '../../logo';
import styles from './CheckoutHeader.module.scss';

export const CheckoutHeader = () => {
  const { t } = useTranslation(['header']);
  const router = useRouter();
  const pathname = usePathname();
  const locale = useCurrentLocale();

  const isCart = pathname === routes[locale].CART;
  const isCheckout = pathname === routes[locale].CHECKOUT;
  const isCheckoutSuccess = pathname?.startsWith(
    routes[locale].CHECKOUT_STATUS
  );

  return (
    <header className={styles.checkoutHeader__wrapper}>
      <div className={styles.checkoutHeader__container}>
        <div className="container">
          {isCheckoutSuccess ? (
            <div />
          ) : (
            <Link
              prefetch={false}
              href={routes[locale].HOME}
              className={styles.checkoutHeader__back}
              onClick={(event) => {
                event.preventDefault();
                if (isCart) {
                  router.push(routes[locale].HOME);
                } else if (isCheckout) {
                  router.push(routes[locale].CART);
                } else {
                  router.push(routes[locale].HOME);
                }
              }}
            >
              <ArrowBack />{' '}
              <span>
                {t(
                  isCart
                    ? 'checkoutHeader.goBackToStore'
                    : 'checkoutHeader.goBackToCart'
                )}
              </span>
            </Link>
          )}

          <Link
            prefetch={false}
            href={routes[locale].HOME}
            className={styles.checkoutHeader__logo}
          >
            <Logo className={styles.logo} />
          </Link>

          {locale === LOCALE.PL ? (
            <div className={styles.checkoutHeader__contact}>
              <a
                className={styles['checkoutHeader__contact--phone']}
                href={`tel:${t('common:common.org.phone') || ''}`}
              >
                {t('checkoutHeader.contact1')}
              </a>
              <div className={styles['checkoutHeader__contact--opening']}>
                {t('checkoutHeader.contact2')}
              </div>
            </div>
          ) : (
            <span />
          )}
        </div>
      </div>
    </header>
  );
};
